import { Flex } from '@chakra-ui/react';
import Header from '../../components/Header';

const StationDashboard = () => {
  return (
    <Flex flexDirection="column">
      <Header title="Dashboard Stase" />
    </Flex>
  );
};

export default StationDashboard;
